<template>
  <el-dialog
    title="品牌导入"
    :visible.sync="centerDialogVisible"
    width="40%"
    center
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="上传文件" prop="file">
        <el-upload
          :action="`${BASE.PRO1}/categories/import/brand`"
          :headers="{ token: token }"
          ref="upload"
          :data="{ id: ruleForm.id }"
          accept=".xlsx"
          :on-success="successFile"
          :on-error="errorFile"
          :before-remove="beforeRemove"
          :on-exceed="onExceed"
          :on-change="onChange"
          class="upload-demo"
          :multiple="false"
          :limit="1"
          :auto-upload="false"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传.xlsx, .xls文件</div>
        </el-upload>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="centerDialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="submitFrom"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { BASE } from "@/api";
import debounce from "lodash/debounce";

export default {
  name: "brandIntroduction",
  props: {},
  data() {
    return {
      BASE,
      token: sessionStorage.getItem("token"),
      loading: false,
      centerDialogVisible: false,
      ruleForm: {
        id: "",
        file: "",
      }, // 表单数据
      rules: {
        file: [
          {
            required: true,
            message: "请上传文件",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    /**
     * 超出数量处理
     */
    onExceed() {
      this.$message.warning(`抱歉，最多只能上传1份文件`);
    },
    /**
     * 上传操作
     */
    successFile(e) {
      console.log(e, "e====");
      this.loading = false;
      if (e.code == 20000) {
        this.centerDialogVisible = false;
        this.$message({
          type: "success",
          message: "导入成功",
        });
        this.$emit("refresh", ""); // 刷新列表
      } else {
        this.tool.message(e.msg, "error");
      }
    },
    /**
     * 上传失败
     */
    errorFile(e) {
      this.ruleForm.file = "";
      this.$message({
        type: "error",
        message: "上传失败",
      });
    },
    /**
     * 删除文件
     */
    beforeRemove(file, fileList) {
      // this.fileList = [];
      this.ruleForm.file = "";
      this.$refs.upload.clearFiles();
    },

    onChange(file) {
      console.log(file, this.fileList, "fileList==");
      this.ruleForm.file = file;
      // 可以在这里对文件进行一些验证
      // this.fileList.push(file);
    },
    /**
     * 提交表单
     */
    submitFrom: debounce(function () {
      console.log(this.fileList, this.$refs.upload, "==");
      if (this.ruleForm.file == "") {
        this.tool.message("请上传文件", "error");
        return;
      } else {
        this.loading = true;
        this.$refs.upload.submit(); // 触发上传
      }
    }, 300),
    /**
     * 初始化
     */
    onInitData(row) {
      this.centerDialogVisible = true;
      this.ruleForm.id = row.id;
      this.$nextTick(() => {
        this.$refs.upload.clearFiles();
        this.ruleForm.file = "";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  .contents {
    padding-top: 30px;
    padding-bottom: 20px;
  }
  /deep/ .el-form {
    margin-left: 120px;
    margin-right: 120px;
    &-item__error {
      left: 110px;
    }
  }
  .el-input {
    width: 300px;
  }
}
</style>
